import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import {
  IFilter,
  IMaterialServicioTecnico,
  IPopulate,
  IQueryParam,
  IUsuario,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { ActivosService } from '../../../../../auxiliares/servicios/http/activos.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import {
  IUsuarioConPermiso,
  UsuariosService,
} from '../../../../../auxiliares/servicios/http/usuarios.service';
import { PermisosService } from '../../../../../auxiliares/servicios/http/permisos.service';
import { MaterialesServicioTecnicoService } from '../../../../../auxiliares/servicios/http/materiales-servicio-tecnico.service';
import { especialidadesDeTecnico } from '../../../../../auxiliares/servicios/especialidad-tecnico';
import {
  CrearEditarUsuarioFuncionComponent,
  DataUsuarioFuncion,
} from '../../../../standalone/usuarios-por-funcion/crear-editar-usuario-funcion/crear-editar-usuario-funcion.component';
import {
  AsignarMaterialesTecnicoComponent,
  DataAsignarMaterialesTecnico,
} from '../../../../standalone/asignar-materiales-tecnico/asignar-materiales-tecnico.component';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';
import { fechaCelda } from '../../../../../auxiliares/tabla/celdas';

@Component({
  selector: 'app-listado-choferes',
  templateUrl: './tecnicos.component.html',
  styleUrl: './tecnicos.component.scss',
  standalone: false,
})
export class TecnicosComponent implements OnInit, OnDestroy {
  private formularios = inject(FormularioDialogService);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(UsuariosService);
  private permisosService = inject(PermisosService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  dialog = inject(MatDialog);
  activosService = inject(ActivosService);
  private materialesService = inject(MaterialesServicioTecnicoService);

  // Materiales asignados (tipo 'asignado', estado 'Asignado') por técnico (idUsuario).
  public materialesPorTecnico: Record<string, IMaterialServicioTecnico[]> = {};

  //// Tabla nueva
  public name = 'TecnicosComponent';
  public usuarios?: IUsuario[];

  public totalCount = 0;
  public columnas?: IColumnas<IUsuario>[];

  // Visor de foto (avatar de la columna Foto)
  public fotoVisible = false;
  public fotoUrl = '';
  public fotoAlt = '';

  @HostListener('click', ['$event'])
  onAvatarClick(event: MouseEvent): void {
    const fotoEl = (event.target as HTMLElement).closest(
      '[data-foto-url]',
    ) as HTMLElement | null;
    if (!fotoEl) return;
    this.fotoUrl = fotoEl.getAttribute('data-foto-url')!;
    this.fotoAlt = fotoEl.getAttribute('data-foto-alt') || '';
    this.fotoVisible = true;
    event.stopPropagation();
  }

  //Subs
  public usuarios$?: Subscription;
  public vehiculos$?: Subscription;
  //
  //
  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Servicio Técnico - Crear técnicos'),
    tooltip: 'Crear técnico',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };
  public search: IRegExpSearch = {
    fields: ['usuario', 'identificacionInterna'],
  };
  // FILTROS
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
    // filtroSelector: ['moduloEventosTecnicos'],
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public filtros: IFiltroTabla[] = [];

  public populate: IPopulate = {
    path: 'cliente',
    select: 'nombre',
  };
  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  public filterVehiculos: IFilter<IUsuario> = {};
  public queryVehiculos: IQueryParam = {
    filter: JSON.stringify(this.filterVehiculos),
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };
  // Listars
  public async listar(): Promise<void> {
    this.usuarios$?.unsubscribe();
    this.usuarios$ = this.lista2
      .tecnicos(this.query, 30)
      .subscribe(async (data) => {
        this.totalCount = data.totalCount; // Cargar materiales antes de asignar usuarios para que la columna los tenga disponibles en el primer render.
        const ids = (data.datos || []).map((u) => u._id!).filter(Boolean);
        await this.cargarMateriales(ids);
        this.usuarios = data.datos;
      });
  }

  // Trae los materiales asignados de los técnicos visibles y los agrupa por idUsuario.
  private async cargarMateriales(ids: string[]): Promise<void> {
    if (!ids.length) {
      this.materialesPorTecnico = {};
      return;
    }
    const filter: Record<string, unknown> = {
      idUsuario: { $in: ids },
      tipo: 'asignado',
      estado: 'Asignado',
    };
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      unlimited: true,
      includeChildren: true,
    };
    try {
      const res = await this.materialesService.getFiltered(query);
      const map: Record<string, IMaterialServicioTecnico[]> = {};
      for (const m of res.datos || []) {
        if (!m.idUsuario) continue;
        (map[m.idUsuario] ??= []).push(m);
      }
      this.materialesPorTecnico = map;
    } catch (error) {
      console.error(error);
      this.materialesPorTecnico = {};
    }
  }

  // Agrupa los materiales de un técnico por nombre y suma sus cantidades.
  // Marca si es un dispositivo del sistema (tiene tipoEntidad) para resaltarlo.
  private resumenMateriales(
    idUsuario: string,
  ): { nombre: string; cantidad: number; esDispositivo: boolean }[] {
    const mats = this.materialesPorTecnico[idUsuario] ?? [];
    const map = new Map<string, { cantidad: number; esDispositivo: boolean }>();
    for (const m of mats) {
      const nombre = m.descripcion || m.idEntidad || 'Material';
      const prev = map.get(nombre) ?? { cantidad: 0, esDispositivo: false };
      map.set(nombre, {
        cantidad: prev.cantidad + (m.cantidad ?? 1),
        esDispositivo: prev.esDispositivo || !!m.tipoEntidad,
      });
    }
    return [...map.entries()].map(([nombre, v]) => ({
      nombre,
      cantidad: v.cantidad,
      esDispositivo: v.esDispositivo,
    }));
  }

  // Acciones — alta/edición de un PERMISO con rol Técnico (no crea usuarios).
  public async crear() {
    const data: DataUsuarioFuncion = { editando: false, funcion: 'Técnico' };
    const ref = this.formularios.abrir(CrearEditarUsuarioFuncionComponent, {
      tamano: 'grande',
      data,
    });
    ref.afterClosed().subscribe(async (d) => {
      if (d) await this.listar();
    });
  }

  public async editar(usuario: IUsuario) {
    const data: DataUsuarioFuncion = {
      editando: true,
      funcion: 'Técnico',
      permiso: (usuario as IUsuarioConPermiso).permiso,
    };
    const ref = this.formularios.abrir(CrearEditarUsuarioFuncionComponent, {
      tamano: 'grande',
      data,
    });
    ref.afterClosed().subscribe(async (d) => {
      if (d) await this.listar();
    });
  }

  // Asignar materiales al técnico (libres o entidades del sistema). El material
  // se guarda con idUsuario = usuario._id (IUsuario), que es lo que la app mobile
  // usa para filtrar el stock/materiales del técnico.
  public asignarMateriales(usuario: IUsuario) {
    if (!usuario._id) {
      this.helper.notifError('El técnico no tiene un usuario asociado');
      return;
    }
    const data: DataAsignarMaterialesTecnico = { usuario };
    const ref = this.formularios.abrir(AsignarMaterialesTecnicoComponent, {
      tamano: 'grande',
      data,
    });
    ref.afterClosed().subscribe(() => this.listar());
  }

  //Actualmente este no estaba llevando a nada. No sé por qué los técnicos tienen documentos
  public ventanaDocumentos(data: IUsuario) {
    this.navigator.navigate([
      '/',
      'main',
      'documentos',
      'listar',
      'usuario',
      data._id,
    ]);
  }

  public async eliminar(usuario: IUsuario) {
    const idPermiso = (usuario as IUsuarioConPermiso).permiso?._id;
    if (!idPermiso) {
      this.helper.notifError('No se encontró el permiso del usuario');
      return;
    }
    const res = await this.dialogService.confirm(
      'Eliminar Técnico',
      `¿Querés eliminar el permiso de técnico de ${usuario.usuario}? Sus materiales asignados se desvincularán y quedarán a disposición.`,
    );
    if (!res) return;
    try {
      // El backend, al borrar el permiso de técnico, desvincula sus materiales
      // asignados (deja los dispositivos disponibles).
      await this.permisosService.delete(idPermiso);
      this.helper.notifSuccess('Técnico eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    this.columnas = [
      {
        header: { label: 'Foto' },
        row: {
          html: (dato) =>
            HelperService.avatarHtml(
              dato.datosPersonales?.foto,
              dato.datosPersonales?.nombre || dato.usuario,
            ),
        },
      },
      {
        header: {
          label: 'Usuario',
          sortable: true,
          sort: 'usuario',
        },
        row: {
          // Usuario + nombre + fecha de creación (con tooltip) en una columna.
          html: (dato) => {
            const usuario = dato.usuario;
            const nombre = dato.datosPersonales?.nombre;
            const fecha = fechaCelda(dato.fechaCreacion);
            if (!usuario && !nombre && !fecha) return '';
            return `<div class="tabla-celda-col">
                ${usuario ? `<span class="tabla-principal">${escaparHtml(usuario)}</span>` : '<span class="no-info">Sin usuario</span>'}
                ${nombre ? `<span class="tabla-secundario">${escaparHtml(nombre)}</span>` : ''}
                ${fecha ? `<span class="tabla-secundario">Alta ${fecha.slice(0, 10)}</span>` : ''}
              </div>`;
          },
          tooltip: (dato) => {
            const fecha = fechaCelda(dato.fechaCreacion);
            const nombre = dato.datosPersonales?.nombre;
            const partes = [
              `${escaparHtml(dato.usuario ?? '')}${nombre ? ' · ' + escaparHtml(nombre) : ''}`,
              fecha ? `Creado: ${fecha}` : '',
            ].filter(Boolean);
            return partes.length ? partes.join('<br>') : undefined;
          },
          noData: 'Sin usuario',
        },
      },
      // Especialidades (de qué es técnico)
      {
        header: { label: 'Especialidades' },
        row: {
          html: (dato) => {
            const esp = especialidadesDeTecnico(
              (dato as IUsuarioConPermiso).permiso,
            );
            if (!esp.length) return '';
            return `<span>${esp.map((t) => escaparHtml(t)).join(', ')}</span>`;
          },
          noData: 'Sin especialidades',
        },
      },
      // Materiales asignados — lista con la cantidad de cada material.
      {
        header: { label: 'Materiales' },
        row: {
          html: (dato) => {
            const items = this.resumenMateriales(dato._id ?? '');
            if (!items.length) return '';
            const rows = items
              .slice(0, 6)
              .map((i) => {
                // Dispositivos del sistema: con el ícono de dispositivo
                const icono = i.esDispositivo
                  ? '<span class="material-symbols-outlined">router</span>'
                  : '';
                return `<div class="tabla-linea">${icono}<span>${escaparHtml(i.nombre)} <b>×${i.cantidad.toLocaleString('es-AR')}</b></span></div>`;
              })
              .join('');
            const extra =
              items.length > 6
                ? `<span class="tabla-secundario">y ${items.length - 6} más</span>`
                : '';
            return `<div class="tabla-celda-col">${rows}${extra}</div>`;
          },
          // Los que no entran en la celda, en el tooltip
          tooltip: (dato) => {
            const items = this.resumenMateriales(dato._id ?? '');
            return items.length > 6
              ? items
                  .map((i) => `${escaparHtml(i.nombre)} ×${i.cantidad}`)
                  .join('<br>')
              : undefined;
          },
          noData: 'Sin materiales',
        },
      },
    ];
    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        this.columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }

    this.columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () =>
              !this.helper.tienePermiso('Servicio Técnico - Editar técnicos'),
          },
          {
            tipo: 'material',
            icon: 'inventory_2',
            tooltip: 'Asignar materiales',
            click: (dato) => this.asignarMateriales(dato),
            disabled: () =>
              !this.helper.tienePermiso('Servicio Técnico - Editar técnicos'),
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () =>
              !this.helper.tienePermiso('Servicio Técnico - Eliminar técnicos'),
          },
        ],
      },
    });
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
  }

  ngOnDestroy() {
    this.usuarios$?.unsubscribe();
    this.vehiculos$?.unsubscribe();
  }
}
